/* UMMAH scroll reveal. Marks section children with .u-reveal and raises them
   into view on first intersection. Content is never hidden without JS, and
   prefers-reduced-motion disables the effect entirely (CSS gate). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SELECTORS = [
    '.ummah-trust__item',
    '.ummah-cats__card',
    '.ummah-featured .product-card',
    '.ummah-gifting__item',
    '.ummah-story__art, .ummah-story__text > *',
    '.ummah-rvs__summary, .ummah-rvs__card',
    '.ummah-nl__inner > *'
  ].join(',');
  function prep(scope) {
    var els = scope.querySelectorAll(SELECTORS);
    var perParent = new Map();
    els.forEach(function (el) {
      if (el.classList.contains('u-reveal')) return;
      var p = el.parentElement;
      var i = perParent.get(p) || 0;
      perParent.set(p, i + 1);
      el.style.setProperty('--u-i', Math.min(i, 7));
      el.classList.add('u-reveal');
      io.observe(el);
    });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('u-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function start() { prep(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { prep(e.target); });
})();
